"use client";

import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TrainerOverview() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: cardRef,
    isVisible: isCardVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="trainer-overview" className="relative w-full bg-background pt-[128px] pb-24 lg:pb-32 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583198/img/koh_samui_bg.png)] bg-cover bg-center opacity-20 pointer-events-none" aria-hidden="true" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col lg:flex-row items-center lg:items-start">
          
          {}
          <div ref={imageRef} className={`w-full lg:w-[60%] relative h-[500px] sm:h-[600px] lg:h-[850px] rounded-2xl lg:rounded-3xl overflow-hidden shadow-2xl transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583198/img/dawid_kasperski_portrait_color.png" alt="Dawid Kasperski Portrait" className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-[2000ms] ease-out hover:scale-105" />
            {}
            <div className="absolute inset-0 bg-gradient-to-t from-background/40 to-transparent pointer-events-none" />
          </div>

          {}
          <div className="w-full lg:w-[40%] flex flex-col lg:-ml-16 lg:mt-40 relative z-20 mt-12 lg:mt-0">
            
            {}
            <div ref={headerRef} className={`transition-all duration-1000 delay-200 ease-out ${isHeaderVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
              <h2 className="font-serif font-black text-6xl sm:text-7xl lg:text-[7rem] leading-[0.85] uppercase tracking-tighter text-foreground mb-8 drop-shadow-lg">
                Dawid
                <br />
                Kasperski
              </h2>
            </div>

            {}
            <div ref={cardRef} className={`transition-all duration-1000 delay-400 ease-out ${isCardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              <Card className="bg-card/70 backdrop-blur-xl border border-primary/10 shadow-xl overflow-hidden">
                <CardContent className="p-8 sm:p-10">
                  <p className="font-sans font-medium text-lg sm:text-xl text-foreground/90 leading-relaxed mb-10">
                    With over a decade of professional fighting experience across the globe, Dawid brings world-class striking techniques and unparalleled mental conditioning to every training session. His approach blends traditional martial arts discipline with modern sports science.
                  </p>

                  {}
                  <div className="flex flex-col sm:flex-row gap-6 sm:gap-12 border-t border-border/50 pt-8">
                    <div className="flex flex-col gap-1">
                      <span className="font-mono text-primary font-bold text-lg tracking-wider">
                        PRO FIGHTER
                      </span>
                      <span className="text-sm text-muted-foreground font-sans uppercase tracking-widest">
                        Status
                      </span>
                    </div>
                    <div className="flex flex-col gap-1">
                      <span className="font-mono text-primary font-bold text-lg tracking-wider">
                        HEAD COACH
                      </span>
                      <span className="text-sm text-muted-foreground font-sans uppercase tracking-widest">
                        Role
                      </span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>

          </div>
        </div>
      </div>
    </section>;
}